import classNames from 'classnames';
import { _ } from '/@/locale';
import styles from './styles.module.css';

const Pills = ({
    type,
    crops = [],
    maxWidth,
}: {
    type: {
        id: number;
        en: string;
        es: string;
        pt: string;
    };
    crops: { id: string; name: { en: string; es: string; pt: string } }[];
    maxWidth: boolean;
}) => {
    return (
        <div className={styles.pills}>
            {type && (
                <div
                    className={classNames(
                        styles.pill,
                        styles.typeDefault,
                        styles[`type-${type?.en?.split(' ')?.[0]?.toLowerCase()}`],
                        maxWidth && styles.maxWidth
                    )}
                >
                    {_(type)}
                </div>
            )}
            {crops.map((c, index) => (
                <div
                    key={`${c.id}-${index}`}
                    className={classNames(
                        styles.pill,
                        styles.typeDefault,
                        styles[`crop-${c.name?.en?.toLowerCase()}`],
                        maxWidth && styles.maxWidth
                    )}
                >
                    {_(c.name)}
                </div>
            ))}
        </div>
    );
};

export default Pills;
